document.addEventListener("DOMContentLoaded", function () {
  const GREEN = "#3bb54a";
  const RED = "#d32f2f";

  const SUMMARY_ROW_SELECTOR = ".iia-id-104404386174";
  const SUMMARY_TEXT_SELECTOR = ".iia-id-104404386174 .iia-title-text";
  const PREFIX = "<strong>Hos leverandører</strong> - ";

  // Normaliser tekst (fjerner NBSP og gør det lowercase)
  function norm(s) {
    return (s || "")
      .replace(/\u00A0/g, " ")     // NBSP -> space
      .replace(/\s+/g, " ")       // mange mellemrum -> ét
      .trim()
      .toLowerCase();
  }

  function setTitleColor(titleEl) {
    if (!titleEl) return;
    const t = norm(titleEl.textContent);

    if (t.includes("ikke på lager")) titleEl.style.color = RED;
    else if (t.includes("på lager")) titleEl.style.color = GREEN;
  }

  // Læs lager-tal for én række så sikkert som muligt
  function getQtyFromRow(row) {
    const titleEl = row.querySelector(".iia-title-text");
    const titleText = norm(titleEl ? titleEl.textContent : row.textContent);

    // 1) Hvis "ikke på lager" står nogen steder, så er det 0
    if (titleText.includes("ikke på lager")) return 0;

    // 2) Tjek threshold tekst (hvis findes)
    const thresholdEl = row.querySelector(".iia-stock-threshold, .iiaStockThreshold");
    const thresholdText = norm(thresholdEl ? thresholdEl.textContent : "");

    if (thresholdText.includes("ikke på lager")) return 0;
    if (thresholdText.includes("20+")) return 20;

    // 3) Tjek qty element (hvis findes)
    const qtyEl = row.querySelector(".iia-qty, .iiaQty");
    if (qtyEl) {
      const q = parseInt(norm(qtyEl.textContent), 10);
      if (!isNaN(q)) return q;
    }

    // 4) Regex i title: "på lager (X)"
    const m = titleText.match(/på lager\s*\((\d+)\)/i);
    if (m && m[1]) return parseInt(m[1], 10) || 0;

    // 5) Sidste fallback: hvis der står "på lager" uden tal -> 1
    if (titleText.includes("på lager")) return 1;

    return 0;
  }

  function applyColorsToAllRows() {
    document.querySelectorAll(".iia-list-item .iia-title-text").forEach(setTitleColor);
  }

  function run() {
    const summaryRow = document.querySelector(SUMMARY_ROW_SELECTOR);
    const summaryText = document.querySelector(SUMMARY_TEXT_SELECTOR);
    if (!summaryRow || !summaryText) return false;

    const allRows = [...document.querySelectorAll(".iia-list-item")];
    if (!allRows.length) return false;

    // Find leverandør-rækker ud fra navnet i .iia-name
    const supplierRows = allRows.filter((row) => {
      const nameEl = row.querySelector(".iia-name");
      const name = norm(nameEl ? nameEl.textContent : "");
      return name.startsWith("leverandør -");
    });

    if (!supplierRows.length) return false;

    let total = 0;

    // Summer og skjul leverandør-linjer (inkl Garmin)
    supplierRows.forEach((row) => {
      total += getQtyFromRow(row);
      row.style.display = "none";
    });

    // Opdater summary
    if (total >= 20) {
      summaryText.innerHTML = PREFIX + "På lager (20+)";
    } else if (total > 0) {
      summaryText.innerHTML = PREFIX + "På lager (" + total + ")";
    } else {
      summaryText.innerHTML = PREFIX + "Ikke på lager";
    }

    summaryRow.style.display = "block";

    // Farver på alle synlige rækker
    applyColorsToAllRows();

    return true;
  }

  // Kør flere gange mens widget loader (uden at spamme)
  let tries = 0;
  const maxTries = 30; // ~7.5 sek
  const timer = setInterval(() => {
    tries++;
    const ok = run();
    if (ok || tries >= maxTries) clearInterval(timer);
  }, 250);
});
